import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { useSite } from "./SiteContext";
import { reducedMotion } from "./fx";
import { displayName } from "./useCatalogue";

/* Product card: 3D tilt + light sheen on hover, size toggle for variants, add-to-enquiry fly */
export default function ProductCard({ product, onQuickView }) {
  const { add, fly } = useSite();
  const navigate = useNavigate();
  const [vi, setVi] = useState(0);
  const cardRef = useRef(null);
  const imgRef = useRef(null);
  const v = product.variants?.[vi];
  const code = v?.code || product.code;
  const spec = v?.size || product.capacity || product.configuration || product.finish;

  const onMove = (e) => {
    const el = cardRef.current;
    if (!el || reducedMotion() || !window.matchMedia("(pointer: fine)").matches) return;
    const r = el.getBoundingClientRect();
    const px = (e.clientX - r.left) / r.width;
    const py = (e.clientY - r.top) / r.height;
    el.style.transform = `perspective(900px) rotateY(${(px - 0.5) * 7}deg) rotateX(${(0.5 - py) * 7}deg)`;
    el.style.setProperty("--sx", `${px * 100}%`);
    el.style.setProperty("--sy", `${py * 100}%`);
  };
  const onLeave = () => { if (cardRef.current) cardRef.current.style.transform = ""; };

  const openDetail = () => navigate(`/product/${product.code}`);

  return (
    <article
      ref={cardRef}
      className="pcard"
      onMouseMove={onMove}
      onMouseLeave={onLeave}
      data-testid={`product-card-${product.code}`}
    >
      <div className="pcard-imgwrap" onClick={openDetail} role="link" aria-label={`View ${product.name}`}>
        <img ref={imgRef} src={product.image} alt={product.name} loading="lazy" />
        <span className="pcard-sheen" aria-hidden="true" />
      </div>
      <div className="pcard-body">
        <div className="pcard-head">
          <h3 onClick={openDetail}>{displayName(product.name)}</h3>
          <span className="pcard-code">{code}</span>
        </div>
        <p className="pcard-spec">{spec}{product.finish ? ` · ${product.finish}` : ""}</p>
        {product.variants?.length > 1 && (
          <div className="pcard-variants" data-testid={`size-toggle-${product.code}`}>
            {product.variants.map((vv, i) => (
              <button key={vv.code} type="button" className={i === vi ? "on" : ""} onClick={() => setVi(i)}>{vv.size}</button>
            ))}
          </div>
        )}
        <div className="pcard-actions">
          <button
            type="button"
            className="btn btn-ghost pcard-add"
            data-testid={`add-enquiry-${product.code}`}
            onClick={(e) => { e.stopPropagation(); add(product, 1, v?.code); fly(imgRef.current, product.image); }}
          >
            <Plus size={14} /> Add to enquiry
          </button>
          <button type="button" className="pcard-quick" onClick={() => onQuickView(product)} data-testid={`quickview-${product.code}`}>
            Quick view
          </button>
        </div>
      </div>
    </article>
  );
}
